import Fallback from "./fallback.container";

export default Fallback;
